import type * as React from 'react';

function SvgFilter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M21 5H3C2.4473 5 2 5.4478 2 6C2 6.5522 2.4473 7 3 7H21C21.5527 7 22 6.5522 22 6C22 5.4478 21.5527 5 21 5Z"
        fill="currentColor"
      />
      <path
        d="M18 11H6C5.4473 11 5 11.4478 5 12C5 12.5522 5.4473 13 6 13H18C18.5527 13 19 12.5522 19 12C19 11.4478 18.5527 11 18 11Z"
        fill="currentColor"
      />
      <path
        d="M15 17H9C8.4473 17 8 17.4478 8 18C8 18.5522 8.4473 19 9 19H15C15.5527 19 16 18.5522 16 18C16 17.4478 15.5527 17 15 17Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgFilter;
